import { Button, IButtonProps, Icon, Size } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ReactComponentLike } from 'prop-types';
import './CircularIconButton.scss';

export interface ICircularIconButtonProps extends Omit<IButtonProps, 'tag' | 'rounded' | 'type' | 'size'> {
  svg: ReactComponentLike;
  size: Size | 'xl';
  buttonType: 'primary' | 'secondary' | 'danger';
  className?: string | object;
}

const CircularIconButton = (props: ICircularIconButtonProps) => {
  const { svg, size, className, buttonType, ...other } = props;

  const iconSize = getIconSize();

  function getIconSize() {
    switch (size) {
      case Size.SMALL:
        return 16;
      case Size.MEDIUM:
        return 22;
      case Size.LARGE:
        return 28;
      case 'xl':
        return 34;
    }
  }

  const classes = classNames(
    {
      'circular-button': true,
      [`circle-size-${size}`]: true,
      'dark-icon': buttonType === 'secondary',
    },
    className
  );

  return (
    <Button className={classes} type={buttonType} {...other}>
      <Icon size={iconSize} svg={svg} />
    </Button>
  );
};

CircularIconButton.defaultProps = {
  ...Button.defaultProps,
  size: Size.MEDIUM,
  shadow: true,
  buttonType: 'primary',
};

export default CircularIconButton;
